import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SET_ERROR_PROMPT_SRGLINES_PAGE } from "externalFeatures/store/actionTypes/smrt/srgLinesActionType";

const SrgLinesErrorPrompt = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isErrorPromptSrgLines: isError, errorMessageSrgLines: errorMessage } =
    useSelector((state) => state.srgLines);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{t("errorPromptTitle")}</AlertTitle>
        {errorMessage}
      </Alert>
    )
  );
};

export default SrgLinesErrorPrompt;
